module.exports = __webpack_public_path__ + "img/user-group.c6a2afd7.png";